import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { filterDuplicates, Minute, RuntimeModules, sortArray } from '@nu-art/ts-common';
import './ATS_CollectionUpgrades.scss';
import { ATS_Backend, TS_AppTools } from '../../components/TS_AppTools/index.js';
import { genericNotificationAction } from '../../components/TS_Notifications/index.js';
import { LL_H_C } from '../../components/Layouts/index.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { Button } from '../../components/Button/Button.js';
import { ModuleFE_CollectionActions } from '../../modules/ModuleFE_CollectionActions.js';
export class ATS_CollectionUpgrades extends ComponentSync {
    static screen = {
        name: 'Collection Upgrades',
        key: 'collection-upgrades',
        renderer: this,
        group: ATS_Backend,
    };
    deriveStateFromProps(nextProps, state) {
        state.upgradableModules ??= sortArray(filterDuplicates(RuntimeModules().filter((module) => {
            return !!module.getCollectionName;
        }), (module) => module.getCollectionName()), item => item.getCollectionName());
        return state;
    }
    __onSyncStatusChanged(module) {
        this.forceUpdate();
    }
    upgradeCollection = async (collectionName, module, e) => {
        await genericNotificationAction(async () => {
            await ModuleFE_CollectionActions.upgrade.collections({
                dbKeys: [module.dbDef.dbKey],
                force: e.metaKey,
            }).setTimeout(5 * Minute).executeSync();
        }, `Upgrading ${collectionName}`);
    };
    upgradeAll = async (e) => {
        await genericNotificationAction(async () => {
            await ModuleFE_CollectionActions.upgrade.all({ force: e.metaKey }).setTimeout(5 * Minute).executeSync();
        }, `Upgrading all collections`);
    };
    render() {
        return _jsxs("div", { className: 'collection-upgrades-page', children: [_jsx(Button, { onClick: e => this.upgradeAll(e), children: "Upgrade All" }), TS_AppTools.renderPageHeader('Collection Upgrades - To force upgrade click + ⌘/ctrl'), _jsx(LL_H_C, { className: 'buttons-container', children: (this.state.upgradableModules || []).map(module => {
                        const name = module.getCollectionName().replace(/-/g, ' ');
                        return _jsxs(Button, { onClick: (e) => this.upgradeCollection(name, module, e), children: [name, " (", module.cache.all().length, ")"] }, name + module.cache.all().length);
                    }) })] });
    }
}
//# sourceMappingURL=ATS_CollectionUpgrades.js.map